import init, * as bindings from './dice_ui-35b4bae403fc2c2f.js';
const wasm = await init({ module_or_path: './dice_ui-35b4bae403fc2c2f_bg.wasm' });


window.wasmBindings = bindings;


dispatchEvent(new CustomEvent("TrunkApplicationStarted", {detail: {wasm}}));